import { PerformanceAudienceChartMetric } from '@/services/endpoints/performanceAudience';

export const CHART_METRICS: PerformanceAudienceChartMetric[] = ['impressions', 'clicks', 'cost', 'ctr'];

export const PLATFORM_CHART_COLORS = {
  google: '#1452E6',
  meta: '#0B1733',
} as const;
